module.exports = __webpack_public_path__ + "img/Frame 219.8a679c0e.png";